import * as React from 'react';

const ArrowRight24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M10.985 4.23a.727.727 0 0 0 .033 1.028l6.416 6.015H4.727a.727.727 0 0 0 0 1.454h12.707l-6.416 6.015a.727.727 0 1 0 .995 1.061l7.757-7.272a.727.727 0 0 0 0-1.062l-7.757-7.272a.727.727 0 0 0-1.028.033"
  }
));
ArrowRight24.Size = 24;
ArrowRight24.Title = "ArrowRight";

export { ArrowRight24 as default };
